import { useState } from 'preact/hooks';

export function Header({ user, workspace, onMenuClick, onLogout }) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <header class="header">
      <button class="header-menu-btn" onClick={onMenuClick}>
        <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      <h1 class="header-title">Vacation Tracker</h1>

      <div class="header-user">
        <div class="header-dropdown">
          <button
            class="header-avatar-btn"
            onClick={() => setDropdownOpen(!dropdownOpen)}
            style="display: flex; align-items: center; gap: 0.5rem; background: none; border: none; cursor: pointer;"
          >
            {user?.avatar ? (
              <img src={user.avatar} alt={user.name} class="header-avatar" />
            ) : (
              <div class="header-avatar" style="background: var(--primary); color: white;">
                {user?.name?.charAt(0) || 'U'}
              </div>
            )}
            <span style="color: var(--gray-700); font-weight: 500;">{user?.name}</span>
            <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {dropdownOpen && (
            <div class="header-dropdown-menu">
              <button onClick={() => { setDropdownOpen(false); }}>
                Profile Settings
              </button>
              <button
                onClick={() => {
                  setDropdownOpen(false);
                  onLogout();
                }}
                style="color: var(--danger);"
              >
                Sign Out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
